// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3Sw5R","frame":"Modal_frame__3dkGO","colorBox":"Modal_colorBox__TI8_Y"};